import { DestinationState, DestinationStore, destinationStore } from '@/scopes/destinations/infrastructure/store/destination-store'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useDestinationStoreSelector<T, A extends unknown[] = []>(selector: (state: DestinationState, ...args: A) => T, ...args: A): T {
  const store = useStore(destinationStore, identity<DestinationStore>)
  return selector(store, ...args)
}
